<script setup>
import { ref } from 'vue';
const show =ref(false)
const props = defineProps({
    data: {
        type: Array,
        default: [],
    }
})
</script>
<template>
  <div class="bg-red-800 text-white rounded-md border border-red-700">
    <!-- Header -->
    <div
      class="px-4 py-2 flex items-center justify-between cursor-pointer"
      @click="show = !show"
    >
      <div class="flex items-center gap-2">
        <img src="/warning-triangle.svg" class="w-5 h-5" />
        <p class="text-sm font-semibold">{{$t('warning')}}</p>
      </div>
      <div
        class="warn-ShowHide transition-transform duration-150"
        :class="{ 'opened': show }"
      />
    </div>

    <!-- Content -->
    <div v-if="show" class="px-4 pb-2 pt-1 border-t border-red-700">
      <div
        v-for="msg in data"
        :key="msg.txt"
        class="text-sm text-gray-200 py-1 break-words whitespace-pre-wrap"
      >
        <p v-html="msg.txt"></p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.warn-ShowHide {
  @apply w-5 h-5 cursor-pointer rotate-180;
  mask-image: url('/chevron-down.svg');
  -webkit-mask-image: url('/chevron-down.svg');
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: white;
}
.warn-ShowHide.opened {
  @apply rotate-0;
}
</style>